import { EditTemplateHelpers } from "../Helpers/EditTemplateHelpers";
import {
  EDIT_TEMPLATE_QUESTION_SCHEMA,
  TEMPLATE_NAME_ENUMS,
} from "./enums/editTemplateEnums";

export const USER_TYPE = "c2mdUserUserType";
export const USER_DATA = "userData";
export const ADMIN_USER = "Admin";
export const CLINIC_ADMIN_USER = "ClinicAdmin";
export const CLINIC_ADMIN = "ClinicAdmin";
export const USER_TOKEN = "c2mdUserToken";
export const digisetu_CLINIC_ID = "14";
export const DOCTOR = "Doctor";
export const NURSE = "Nurse";
export const COORDINATOR = "Coordinator";
export const SUPERADMIN = "SuperAdmin";
export const SELECTEDPROJECT = "selectedProject";
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 15 minutes in milliseconds

export const modalNames = {
  RPM_APPOINTMENT_HISTORY_MODAL: "rpmAppointmentHistoryModal",
  RPM_AUDIT_LOG_MODAL: "rpmAuditLogModal",
};

export const userStatusArray = [
  "Active",
  "Paused",
  "Cancelled",
  "Stoped",
  "Inactive",
];

export const TEMPLATE_NAME_MAPPER = {
  [TEMPLATE_NAME_ENUMS.HOPI]: "History of Presenting Illness (HOPI) - Adult",
  [TEMPLATE_NAME_ENUMS.HOPI_PEDIATRIC]:
    "History of Presenting Illness (HOPI) - Pediatric",
  [TEMPLATE_NAME_ENUMS.OBGYN]: "Obstetrics and Gynecology related - History",
  [TEMPLATE_NAME_ENUMS.PPFM]: "Past, Personal and Family History",
  [TEMPLATE_NAME_ENUMS.PEV]: "Physical Examination (PE)",
};

export const EditTemplateCategories = {
  [TEMPLATE_NAME_ENUMS.HOPI]:
    EditTemplateHelpers.mapQuestionFromSourceToSchema("hopi_data"),
  [TEMPLATE_NAME_ENUMS.HOPI_PEDIATRIC]:
    EditTemplateHelpers.mapQuestionFromSourceToSchema("hopi_data_pediatric"),
  [TEMPLATE_NAME_ENUMS.PPFM]:
    EditTemplateHelpers.mapQuestionFromSourceToSchema("ppfm"),
  [TEMPLATE_NAME_ENUMS.OBGYN]:
    EditTemplateHelpers.mapQuestionFromSourceToSchema("obgyn"),
  [TEMPLATE_NAME_ENUMS.PEV]:
    EditTemplateHelpers.mapQuestionFromSourceToSchema("gpe"),
};
